module.exports = __webpack_public_path__ + "static/media/inactive-map-marker.7a127447.svg";